import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
var _0x1933e8 = _0x587b;
function _0x587b(_0x1c8454, _0x283a2c) {
  var _0x316183 = _0x3161();
  return _0x587b = function _0x587b(_0x587b39, _0x17f87a) {
    _0x587b39 = _0x587b39 - 0x69;
    var _0x25f145 = _0x316183[_0x587b39];
    return _0x25f145;
  }, _0x587b(_0x1c8454, _0x283a2c);
}
(function (_0x52bbf2, _0xc8a742) {
  var _0x2f136d = _0x587b,
    _0x453edd = _0x52bbf2();
  while (!![]) {
    try {
      var _0x5e45df = -parseInt(_0x2f136d(0xb9)) / 0x1 * (-parseInt(_0x2f136d(0x19a)) / 0x2) + -parseInt(_0x2f136d(0xd1)) / 0x3 * (-parseInt(_0x2f136d(0x19d)) / 0x4) + -parseInt(_0x2f136d(0x17e)) / 0x5 + parseInt(_0x2f136d(0x145)) / 0x6 * (parseInt(_0x2f136d(0x114)) / 0x7) + -parseInt(_0x2f136d(0x1b3)) / 0x8 + -parseInt(_0x2f136d(0x74)) / 0x9 + parseInt(_0x2f136d(0x7b)) / 0xa * (parseInt(_0x2f136d(0xe4)) / 0xb);
      if (_0x5e45df === _0xc8a742) break;else _0x453edd['push'](_0x453edd['shift']());
    } catch (_0x5e1392) {
      _0x453edd['push'](_0x453edd['shift']());
    }
  }
})(_0x3161, 0x8aae0);
function __awaiter(_0x4b3dde, _0x289e62, _0xfe07a8, _0x4f6518) {
  function _0x45b1c4(_0x538f04) {
    return _0x538f04 instanceof _0xfe07a8 ? _0x538f04 : new _0xfe07a8(function (_0x1f4df4) {
      _0x1f4df4(_0x538f04);
    });
  }
  return new (_0xfe07a8 || (_0xfe07a8 = Promise))(function (_0x2c7d0f, _0x315bf0) {
    var _0x13fb7b = _0x587b;
    function _0x2e617e(_0x11e240) {
      try {
        _0x457c71(_0x4f6518['next'](_0x11e240));
      } catch (_0x45d44b) {
        _0x315bf0(_0x45d44b);
      }
    }
    function _0x5eec6c(_0x174515) {
      var _0x1e16d5 = _0x587b;
      try {
        _0x457c71(_0x4f6518[_0x1e16d5(0x81)](_0x174515));
      } catch (_0x4ccbdb) {
        _0x315bf0(_0x4ccbdb);
      }
    }
    function _0x457c71(_0x598ccb) {
      var _0x36427f = _0x587b;
      _0x598ccb[_0x36427f(0x1b4)] ? _0x2c7d0f(_0x598ccb['value']) : _0x45b1c4(_0x598ccb[_0x36427f(0x90)])[_0x36427f(0x15a)](_0x2e617e, _0x5eec6c);
    }
    _0x457c71((_0x4f6518 = _0x4f6518[_0x13fb7b(0x136)](_0x4b3dde, _0x289e62 || []))[_0x13fb7b(0x112)]());
  });
}
var EventModule;
(function (_0x2c03fb) {
  var _0x3383d9 = _0x587b;
  _0x2c03fb[_0x3383d9(0x123)] = _0x3383d9(0x123), _0x2c03fb['PROCESS_INIT'] = _0x3383d9(0x193), _0x2c03fb['PROCESS_ERROR'] = _0x3383d9(0x1a9), _0x2c03fb[_0x3383d9(0x159)] = _0x3383d9(0x159), _0x2c03fb[_0x3383d9(0x130)] = _0x3383d9(0x130), _0x2c03fb[_0x3383d9(0x8b)] = _0x3383d9(0x8b), _0x2c03fb[_0x3383d9(0x14e)] = 'MODULE_CLOSED', _0x2c03fb['MODULE_LOAD_FAILED'] = _0x3383d9(0x18e), _0x2c03fb[_0x3383d9(0x174)] = _0x3383d9(0x174), _0x2c03fb[_0x3383d9(0x166)] = 'SKIP_FINGERPRINTS';
})(EventModule || (EventModule = {}));
var FadEnvironment;
(function (_0x558a3a) {
  var _0x9313d7 = _0x587b;
  _0x558a3a[_0x558a3a[_0x9313d7(0x78)] = 0x1] = _0x9313d7(0x78), _0x558a3a[_0x558a3a[_0x9313d7(0x1a4)] = 0x2] = _0x9313d7(0x1a4), _0x558a3a[_0x558a3a[_0x9313d7(0x12f)] = 0x3] = 'PROD';
})(FadEnvironment || (FadEnvironment = {}));
var AdditionaInfoProcessType;
(function (_0x13ddcb) {
  var _0x588ea5 = _0x587b;
  _0x13ddcb[_0x13ddcb['VALIDATION'] = 0x1] = 'VALIDATION', _0x13ddcb[_0x13ddcb[_0x588ea5(0x108)] = 0x2] = _0x588ea5(0x108), _0x13ddcb[_0x13ddcb[_0x588ea5(0xde)] = 0x3] = _0x588ea5(0xde), _0x13ddcb[_0x13ddcb[_0x588ea5(0x169)] = 0x4] = _0x588ea5(0x169), _0x13ddcb[_0x13ddcb[_0x588ea5(0x1a3)] = 0x5] = _0x588ea5(0x1a3);
})(AdditionaInfoProcessType || (AdditionaInfoProcessType = {}));
var IframePermissions;
(function (_0x3fa5ea) {
  var _0x3aba35 = _0x587b;
  _0x3fa5ea[_0x3aba35(0x6e)] = _0x3aba35(0x70), _0x3fa5ea[_0x3aba35(0x102)] = _0x3aba35(0xfb), _0x3fa5ea['GEOLOCATION_CAMERA_MICROPHONE'] = _0x3aba35(0x10d);
})(IframePermissions || (IframePermissions = {}));
var RegulaCaptureType;
(function (_0x2e1b69) {
  var _0x6303ba = _0x587b;
  _0x2e1b69[_0x6303ba(0x1a5)] = _0x6303ba(0x1a5), _0x2e1b69[_0x6303ba(0x18d)] = _0x6303ba(0x18d);
})(RegulaCaptureType || (RegulaCaptureType = {}));
var FAD_IFRAME_UAT = _0x1933e8(0x93),
  FAD_IFRAME_UATHA = _0x1933e8(0xb6),
  FAD_IFRAME_PROD = _0x1933e8(0x146),
  MODULES_URL = {
    'FACETEC': _0x1933e8(0x73),
    'IDENTY': _0x1933e8(0x17a),
    'VIDEOAGREEMENT': _0x1933e8(0x15d),
    'VIDEOTAPING': _0x1933e8(0x12e),
    'SIGNATURE': _0x1933e8(0x17f),
    'VALIDATION_ID': _0x1933e8(0xbc),
    'ACUANT': _0x1933e8(0x98),
    'ACUANT_10': 'fad-iframe-acuant-beta',
    'REGULA': 'fad-iframe-regula-id',
    'CAPTURE_ID': 'fad-iframe-capture-id',
    'IDENTY_FACE': 'fad-iframe-identy-face',
    'TOC_LIVENESS': 'fad-iframe-liveness-toc'
  },
  FAD_WEB_UAT = _0x1933e8(0x8c),
  FAD_WEB_UATHA = _0x1933e8(0x149),
  FAD_WEB_PROD = _0x1933e8(0x8d),
  FAD_BIOMETRICS_UAT = 'uONj0U8CQuvucMY1HKa6UQc5E60sfjyqjVtaislXVXc8Uey+DOoJPvziGzg5qsgmOUslF0HHN6gqivGA3fS3kg7Q+wjsM4b8GsIB',
  FAD_BIOMETRICS_UATHA = _0x1933e8(0x155),
  FAD_BIOMETRICS_PROD = _0x1933e8(0xea),
  FAD_DOMAIN = _0x1933e8(0x104),
  YEK = _0x1933e8(0x12d),
  VI = _0x1933e8(0x82),
  SDK_OPTIONS = {
    'environment': FadEnvironment[_0x1933e8(0x78)],
    'security': {
      'domain': FAD_DOMAIN,
      'enable': !![]
    }
  };
var LegendSpeedMode;
(function (_0xc20b83) {
  var _0x33c589 = _0x1933e8;
  _0xc20b83[_0xc20b83['SLOW'] = 0x1] = _0x33c589(0x13d), _0xc20b83[_0xc20b83[_0x33c589(0xcf)] = 0x2] = _0x33c589(0xcf), _0xc20b83[_0xc20b83[_0x33c589(0x139)] = 0x3] = _0x33c589(0x139);
})(LegendSpeedMode || (LegendSpeedMode = {}));
var IDS_ALLOWED;
(function (_0x3e4089) {
  var _0x2851f1 = _0x1933e8;
  _0x3e4089[_0x2851f1(0xa2)] = 'ID_MEX_FRONT', _0x3e4089[_0x2851f1(0xed)] = _0x2851f1(0xed), _0x3e4089['ID_PASSPORT'] = _0x2851f1(0xc6);
})(IDS_ALLOWED || (IDS_ALLOWED = {}));
var SandBoxPermissions;
(function (_0xa6ff7a) {
  var _0x12c702 = _0x1933e8;
  _0xa6ff7a[_0x12c702(0x122)] = _0x12c702(0x1a2), _0xa6ff7a[_0x12c702(0x10b)] = _0x12c702(0x128), _0xa6ff7a[_0x12c702(0xcd)] = _0x12c702(0x101), _0xa6ff7a[_0x12c702(0xf1)] = _0x12c702(0x97), _0xa6ff7a[_0x12c702(0x6f)] = '';
})(SandBoxPermissions || (SandBoxPermissions = {}));
var AcuantErrorCode;
(function (_0x289c10) {
  var _0x3eae3b = _0x1933e8;
  _0x289c10[_0x289c10['REQUIRED_CREDENTIALS'] = -0x1] = _0x3eae3b(0xa4), _0x289c10[_0x289c10[_0x3eae3b(0x77)] = -0x2] = _0x3eae3b(0x77), _0x289c10[_0x289c10[_0x3eae3b(0x1a6)] = -0x3] = 'UNSUPPORTED_CAMERA', _0x289c10[_0x289c10[_0x3eae3b(0x11d)] = -0x4] = _0x3eae3b(0x11d), _0x289c10[_0x289c10[_0x3eae3b(0xdc)] = -0x5] = 'FAIL_CREATION_INSTANCE_DOCUMENT', _0x289c10[_0x289c10['FAIL_UPLOAD_IMAGE'] = -0x6] = _0x3eae3b(0x129), _0x289c10[_0x289c10[_0x3eae3b(0x150)] = -0x7] = _0x3eae3b(0x150), _0x289c10[_0x289c10[_0x3eae3b(0x19f)] = -0x8] = _0x3eae3b(0x19f), _0x289c10[_0x289c10[_0x3eae3b(0x153)] = -0x9] = _0x3eae3b(0x153), _0x289c10[_0x289c10[_0x3eae3b(0x6b)] = -0xa] = 'FACE_IMAGE_NOT_FOUND', _0x289c10[_0x289c10[_0x3eae3b(0x107)] = -0xb] = 'RESOURCES_COULD_NOT_BE_LOADED', _0x289c10[_0x289c10['UNEXPECTED_ACUANT_ERROR'] = -0xc] = _0x3eae3b(0x16a), _0x289c10[_0x289c10[_0x3eae3b(0x13b)] = -0xd] = _0x3eae3b(0x13b), _0x289c10[_0x289c10['IMAGE_BLURRY'] = -0xe] = _0x3eae3b(0xe3), _0x289c10[_0x289c10[_0x3eae3b(0xae)] = -0xf] = _0x3eae3b(0xae), _0x289c10[_0x289c10[_0x3eae3b(0xbf)] = -0x10] = 'EQUAL_SIDE', _0x289c10[_0x289c10['IMAGE_GLARED'] = -0x11] = _0x3eae3b(0x94), _0x289c10[_0x289c10[_0x3eae3b(0x1be)] = -0x12] = 'DPI_NOT_ENOUGH', _0x289c10[_0x289c10[_0x3eae3b(0xad)] = -0x13] = 'DIFFERENT_CARD_TYPE';
})(AcuantErrorCode || (AcuantErrorCode = {}));
var AcuantLegacyErrorCode;
(function (_0x1b9efc) {
  var _0x560e24 = _0x1933e8;
  _0x1b9efc[_0x1b9efc[_0x560e24(0xa4)] = -0x1] = _0x560e24(0xa4), _0x1b9efc[_0x1b9efc[_0x560e24(0x77)] = -0x2] = _0x560e24(0x77), _0x1b9efc[_0x1b9efc[_0x560e24(0x1a6)] = -0x3] = _0x560e24(0x1a6), _0x1b9efc[_0x1b9efc[_0x560e24(0x11d)] = -0x4] = _0x560e24(0x11d), _0x1b9efc[_0x1b9efc['FAIL_CREATION_INSTANCE_DOCUMENT'] = -0x5] = 'FAIL_CREATION_INSTANCE_DOCUMENT', _0x1b9efc[_0x1b9efc[_0x560e24(0x129)] = -0x6] = _0x560e24(0x129), _0x1b9efc[_0x1b9efc['FAIL_GET_OCR'] = -0x7] = _0x560e24(0x150), _0x1b9efc[_0x1b9efc[_0x560e24(0x19f)] = -0x8] = 'FAIL_GET_FACE_IMAGE', _0x1b9efc[_0x1b9efc[_0x560e24(0x153)] = -0x9] = _0x560e24(0x153), _0x1b9efc[_0x1b9efc['FACE_IMAGE_NOT_FOUND'] = -0xa] = _0x560e24(0x6b), _0x1b9efc[_0x1b9efc['RESOURCES_COULD_NOT_BE_LOADED'] = -0xb] = _0x560e24(0x107), _0x1b9efc[_0x1b9efc['UNEXPECTED_ACUANT_ERROR'] = -0xc] = _0x560e24(0x16a), _0x1b9efc[_0x1b9efc[_0x560e24(0x13b)] = -0xd] = _0x560e24(0x13b), _0x1b9efc[_0x1b9efc[_0x560e24(0xe3)] = -0xe] = _0x560e24(0xe3);
})(AcuantLegacyErrorCode || (AcuantLegacyErrorCode = {}));
var CaptureIdErrorCode;
(function (_0x5af0b3) {
  var _0x1003cb = _0x1933e8;
  _0x5af0b3[_0x5af0b3[_0x1003cb(0xb7)] = -0x1] = _0x1003cb(0xb7), _0x5af0b3[_0x5af0b3['NOT_ACCEPT_CAMERA_PERMISSION'] = -0x2] = _0x1003cb(0xf4), _0x5af0b3[_0x5af0b3['NOT_READABLE_CAMERA'] = -0x3] = 'NOT_READABLE_CAMERA', _0x5af0b3[_0x5af0b3[_0x1003cb(0x14c)] = -0x4] = _0x1003cb(0x14c), _0x5af0b3[_0x5af0b3[_0x1003cb(0x18f)] = -0x64] = 'USER_REQUIRED', _0x5af0b3[_0x5af0b3[_0x1003cb(0xda)] = -0x65] = _0x1003cb(0xda), _0x5af0b3[_0x5af0b3[_0x1003cb(0xe2)] = -0x66] = _0x1003cb(0xe2), _0x5af0b3[_0x5af0b3[_0x1003cb(0x110)] = -0x67] = 'MODEL_FAILED', _0x5af0b3[_0x5af0b3['TF_LITE_ERROR'] = -0x68] = _0x1003cb(0xce), _0x5af0b3[_0x5af0b3['TF_ERROR'] = -0x69] = _0x1003cb(0x10f), _0x5af0b3[_0x5af0b3[_0x1003cb(0x1bc)] = -0x6a] = _0x1003cb(0x1bc);
})(CaptureIdErrorCode || (CaptureIdErrorCode = {}));
var FacetecErrorCodeSession;
(function (_0x4975e3) {
  var _0x403c9d = _0x1933e8;
  _0x4975e3[_0x4975e3[_0x403c9d(0x196)] = 0x0] = _0x403c9d(0x196), _0x4975e3[_0x4975e3[_0x403c9d(0x19c)] = 0x1] = _0x403c9d(0x19c), _0x4975e3[_0x4975e3[_0x403c9d(0xef)] = 0x2] = _0x403c9d(0xef), _0x4975e3[_0x4975e3[_0x403c9d(0x197)] = 0x3] = _0x403c9d(0x197), _0x4975e3[_0x4975e3[_0x403c9d(0xf5)] = 0x4] = _0x403c9d(0xf5), _0x4975e3[_0x4975e3[_0x403c9d(0x109)] = 0x5] = _0x403c9d(0x109), _0x4975e3[_0x4975e3[_0x403c9d(0xc1)] = 0x6] = 'LANDSCAPE_MODE_NOT_ALLOWED', _0x4975e3[_0x4975e3[_0x403c9d(0x6c)] = 0x7] = _0x403c9d(0x6c), _0x4975e3[_0x4975e3[_0x403c9d(0x179)] = 0x8] = _0x403c9d(0x179), _0x4975e3[_0x4975e3[_0x403c9d(0xc3)] = 0x9] = _0x403c9d(0xc3), _0x4975e3[_0x4975e3['USER_CANCELLED_WHEN_ATTEMPTING_TO_GET_CAMERA_PERMISSIONS'] = 0xa] = _0x403c9d(0x105), _0x4975e3[_0x4975e3[_0x403c9d(0x100)] = 0xb] = _0x403c9d(0x100), _0x4975e3[_0x4975e3[_0x403c9d(0x141)] = 0xc] = _0x403c9d(0x141), _0x4975e3[_0x4975e3[_0x403c9d(0xc7)] = 0xd] = 'NON_PRODUCTION_MODE_DEVICE_KEY_IDENTIFIER_INVALID', _0x4975e3[_0x4975e3[_0x403c9d(0xa0)] = 0xe] = _0x403c9d(0xa0), _0x4975e3[_0x4975e3[_0x403c9d(0x10a)] = 0xf] = _0x403c9d(0x10a), _0x4975e3[_0x4975e3[_0x403c9d(0x17d)] = 0x10] = 'CAMERA_NOT_RUNNING', _0x4975e3[_0x4975e3[_0x403c9d(0xd9)] = 0x11] = _0x403c9d(0xd9), _0x4975e3[_0x4975e3[_0x403c9d(0x11b)] = 0x12] = _0x403c9d(0x11b), _0x4975e3[_0x4975e3[_0x403c9d(0x118)] = 0x13] = _0x403c9d(0x118), _0x4975e3[_0x4975e3['NOT_ALLOWED_USE_IFRAME_CONSTRUCTOR'] = 0x14] = _0x403c9d(0xec), _0x4975e3[_0x4975e3[_0x403c9d(0x7c)] = 0x15] = 'NOT_ALLOWED_USE_NON_IFRAME_CONSTRUCTOR', _0x4975e3[_0x4975e3[_0x403c9d(0x156)] = 0x16] = 'I_FRAME_NOT_ALLOWED_WITHOUT_PERMISSION', _0x4975e3[_0x4975e3[_0x403c9d(0xd8)] = 0x17] = _0x403c9d(0xd8), _0x4975e3[_0x4975e3['RESOURCES_COULD_NOT_BE_LOADED_ON_LAST_INIT'] = 0x18] = _0x403c9d(0xa6), _0x4975e3[_0x4975e3['RESOURCES_COULD_NOT_BE_LOADED'] = 0x19] = _0x403c9d(0x107), _0x4975e3[_0x4975e3['REQUIRED_CREDENTIALS'] = 0x1a] = _0x403c9d(0xa4), _0x4975e3[_0x4975e3[_0x403c9d(0x137)] = 0x1b] = _0x403c9d(0x137), _0x4975e3[_0x4975e3[_0x403c9d(0x19b)] = -0x1] = _0x403c9d(0x19b);
})(FacetecErrorCodeSession || (FacetecErrorCodeSession = {}));
var FacetecErrorCodeStatus;
(function (_0x2c4fc2) {
  var _0x208f6b = _0x1933e8;
  _0x2c4fc2[_0x2c4fc2[_0x208f6b(0x172)] = 0x0] = _0x208f6b(0x172), _0x2c4fc2[_0x2c4fc2[_0x208f6b(0xbd)] = 0x1] = _0x208f6b(0xbd), _0x2c4fc2[_0x2c4fc2[_0x208f6b(0x16b)] = 0x2] = 'NETWORK_ISSUES', _0x2c4fc2[_0x2c4fc2[_0x208f6b(0x96)] = 0x3] = _0x208f6b(0x96), _0x2c4fc2[_0x2c4fc2[_0x208f6b(0x13c)] = 0x4] = 'VERSION_DEPRECATED', _0x2c4fc2[_0x2c4fc2[_0x208f6b(0x12c)] = 0x5] = 'DEVICE_NOT_SUPPORTED', _0x2c4fc2[_0x2c4fc2['DEVICE_IN_LANDSCAPE_MODE'] = 0x6] = 'DEVICE_IN_LANDSCAPE_MODE', _0x2c4fc2[_0x2c4fc2[_0x208f6b(0xeb)] = 0x7] = _0x208f6b(0xeb), _0x2c4fc2[_0x2c4fc2['KEY_EXPIRED_OR_INVALID'] = 0x8] = _0x208f6b(0x15f), _0x2c4fc2[_0x2c4fc2[_0x208f6b(0xac)] = 0x9] = _0x208f6b(0xac), _0x2c4fc2[_0x2c4fc2[_0x208f6b(0xd8)] = 0xa] = _0x208f6b(0xd8), _0x2c4fc2[_0x2c4fc2['RESOURCES_COULD_NOT_BE_LOADED_ON_LAST_INIT'] = 0xb] = _0x208f6b(0xa6);
})(FacetecErrorCodeStatus || (FacetecErrorCodeStatus = {}));
var FacetecErrorType;
(function (_0x5bc562) {
  var _0x277743 = _0x1933e8;
  _0x5bc562['FACETEC_SDK_STATUS'] = 'FaceTecSDKStatus', _0x5bc562['FACETEC_SESSION_STATUS'] = _0x277743(0x7d), _0x5bc562['FACETEC_MIDDLEWARE_ERROR'] = 'FacetecMiddlewareError';
})(FacetecErrorType || (FacetecErrorType = {}));
var IframeFacetecErrorCode;
(function (_0x29fed9) {
  var _0x1d09d1 = _0x1933e8;
  _0x29fed9[_0x29fed9[_0x1d09d1(0x140)] = -0x1] = _0x1d09d1(0x140), _0x29fed9[_0x29fed9[_0x1d09d1(0x163)] = -0x2] = _0x1d09d1(0x163);
})(IframeFacetecErrorCode || (IframeFacetecErrorCode = {}));
var IdentyFaceErrorCode;
(function (_0x409248) {
  var _0x38c347 = _0x1933e8;
  _0x409248[_0x409248[_0x38c347(0xdf)] = -0x1] = _0x38c347(0xdf), _0x409248[_0x409248['IDENTY_GENERIC'] = -0x2] = _0x38c347(0x106), _0x409248[_0x409248[_0x38c347(0x14a)] = 0x64] = _0x38c347(0x14a), _0x409248[_0x409248[_0x38c347(0x16f)] = 0x65] = _0x38c347(0x16f), _0x409248[_0x409248[_0x38c347(0x15c)] = 0x67] = _0x38c347(0x15c), _0x409248[_0x409248[_0x38c347(0x8e)] = 0x68] = 'FEEDBACK_CAMERA_ACQUIRING_FAILED', _0x409248[_0x409248['FEEDBACK_DIALOG_CLOSED'] = 0xca] = _0x38c347(0x182), _0x409248[_0x409248['FEEDBACK_RETRY'] = 0x191] = _0x38c347(0x142), _0x409248[_0x409248[_0x38c347(0x147)] = 0x198] = _0x38c347(0x147), _0x409248[_0x409248[_0x38c347(0x164)] = 0x1f4] = _0x38c347(0x164), _0x409248[_0x409248['TIMEOUT'] = 0x1f5] = _0x38c347(0xef), _0x409248[_0x409248[_0x38c347(0xe1)] = 0x1fa] = _0x38c347(0xe1), _0x409248[_0x409248[_0x38c347(0xca)] = 0x25c] = _0x38c347(0xca);
})(IdentyFaceErrorCode || (IdentyFaceErrorCode = {}));
var IdentyErrorCode;
(function (_0x377d7a) {
  var _0x5ec937 = _0x1933e8;
  _0x377d7a[_0x377d7a['NO_CREDENTIALS'] = -0x1] = _0x5ec937(0x170), _0x377d7a[_0x377d7a['NO_BASE_URL'] = -0x2] = _0x5ec937(0x86), _0x377d7a[_0x377d7a[_0x5ec937(0x171)] = -0x3] = _0x5ec937(0x171), _0x377d7a[_0x377d7a[_0x5ec937(0xd0)] = -0x4] = _0x5ec937(0xd0), _0x377d7a[_0x377d7a[_0x5ec937(0x1ab)] = -0x5] = _0x5ec937(0x1ab), _0x377d7a[_0x377d7a[_0x5ec937(0x106)] = -0x6] = _0x5ec937(0x106), _0x377d7a[_0x377d7a['DEVICE_BROWSER_ERROR'] = -0x7] = _0x5ec937(0x14a), _0x377d7a[_0x377d7a[_0x5ec937(0x16f)] = -0x8] = _0x5ec937(0x16f), _0x377d7a[_0x377d7a[_0x5ec937(0x8e)] = -0x9] = _0x5ec937(0x8e), _0x377d7a[_0x377d7a['ERROR_BROWSER_VERSION_NOT_SUPPORTED'] = -0xa] = _0x5ec937(0x15c), _0x377d7a[_0x377d7a[_0x5ec937(0x14b)] = -0xb] = _0x5ec937(0x14b), _0x377d7a[_0x377d7a[_0x5ec937(0xe1)] = -0xc] = _0x5ec937(0xe1), _0x377d7a[_0x377d7a['ERROR_REQUEST_EXPIRED'] = -0xd] = 'ERROR_REQUEST_EXPIRED', _0x377d7a[_0x377d7a['ERROR_SERVER_INTERNAL'] = -0xe] = _0x5ec937(0x162), _0x377d7a[_0x377d7a[_0x5ec937(0xd5)] = -0xf] = _0x5ec937(0xd5), _0x377d7a[_0x377d7a[_0x5ec937(0x142)] = -0x10] = 'FEEDBACK_RETRY', _0x377d7a[_0x377d7a[_0x5ec937(0x154)] = -0x11] = 'ERROR_CLIENT_NOT_EXISTS', _0x377d7a[_0x377d7a[_0x5ec937(0x19e)] = -0x12] = _0x5ec937(0x19e), _0x377d7a[_0x377d7a[_0x5ec937(0xee)] = -0x13] = _0x5ec937(0xee), _0x377d7a[_0x377d7a[_0x5ec937(0x75)] = -0x14] = 'ERROR_INVALID_FORMAT', _0x377d7a[_0x377d7a[_0x5ec937(0x127)] = -0x15] = 'ERROR_INVALID_MATCH_LEVEL', _0x377d7a[_0x377d7a[_0x5ec937(0xe9)] = -0x16] = _0x5ec937(0xe9), _0x377d7a[_0x377d7a['NO_TEMPLATES_SPECIFIED'] = -0x17] = _0x5ec937(0xb5), _0x377d7a[_0x377d7a[_0x5ec937(0xcb)] = -0x18] = _0x5ec937(0xcb), _0x377d7a[_0x377d7a[_0x5ec937(0x76)] = -0x19] = _0x5ec937(0x76);
})(IdentyErrorCode || (IdentyErrorCode = {}));
var RegulaErrorCode;
(function (_0x339786) {
  var _0x5978ad = _0x1933e8;
  _0x339786[_0x339786[_0x5978ad(0x170)] = -0x1] = _0x5978ad(0x170), _0x339786[_0x339786['NO_LICENSE'] = -0x2] = _0x5978ad(0x71), _0x339786[_0x339786[_0x5978ad(0x115)] = -0x3] = 'NO_CAPTURE_TYPE', _0x339786[_0x339786['REGULA_ERROR'] = -0x4] = _0x5978ad(0x192), _0x339786[_0x339786[_0x5978ad(0x135)] = -0x5] = _0x5978ad(0x135), _0x339786[_0x339786['OCR_NOT_FOUND'] = -0x6] = _0x5978ad(0x16e), _0x339786[_0x339786['ID_NOT_FOUND'] = -0x7] = _0x5978ad(0xf7), _0x339786[_0x339786[_0x5978ad(0x188)] = -0x8] = 'ERROR_LICENSE', _0x339786[_0x339786[_0x5978ad(0x195)] = -0x9] = _0x5978ad(0x195), _0x339786[_0x339786[_0x5978ad(0x134)] = -0xa] = _0x5978ad(0x134), _0x339786[_0x339786[_0x5978ad(0x1aa)] = -0xb] = _0x5978ad(0x1aa), _0x339786[_0x339786[_0x5978ad(0x117)] = -0xc] = _0x5978ad(0x117), _0x339786[_0x339786[_0x5978ad(0x18c)] = -0xd] = 'CARD_MATCH', _0x339786[_0x339786[_0x5978ad(0x1bb)] = 0x1] = 'WASM_ERROR', _0x339786[_0x339786[_0x5978ad(0x113)] = 0x2] = _0x5978ad(0x113), _0x339786[_0x339786[_0x5978ad(0xf2)] = 0x3] = _0x5978ad(0xf2), _0x339786[_0x339786[_0x5978ad(0x9b)] = 0x4] = _0x5978ad(0x9b), _0x339786[_0x339786['UNKNOWN_ERROR'] = 0x5] = 'UNKNOWN_ERROR', _0x339786[_0x339786[_0x5978ad(0x9c)] = 0x6] = _0x5978ad(0x9c), _0x339786[_0x339786[_0x5978ad(0xb0)] = 0x7] = 'CAMERA_UNKNOWN_ERROR', _0x339786[_0x339786[_0x5978ad(0x1ac)] = 0x8] = _0x5978ad(0x1ac), _0x339786[_0x339786[_0x5978ad(0xd6)] = 0x9] = _0x5978ad(0xd6), _0x339786[_0x339786[_0x5978ad(0x133)] = 0xa] = _0x5978ad(0x133), _0x339786[_0x339786[_0x5978ad(0x83)] = 0xb] = 'CONNECTION_ERROR', _0x339786[_0x339786[_0x5978ad(0x69)] = 0xc] = _0x5978ad(0x69), _0x339786[_0x339786['NOT_INITIALIZED'] = 0xd] = 'NOT_INITIALIZED', _0x339786[_0x339786[_0x5978ad(0x91)] = 0xe] = _0x5978ad(0x91), _0x339786[_0x339786[_0x5978ad(0x12a)] = 0xf] = _0x5978ad(0x12a), _0x339786[_0x339786['ALREADY_INITIALIZED'] = 0x10] = _0x5978ad(0xf3), _0x339786[_0x339786[_0x5978ad(0x76)] = 0x11] = _0x5978ad(0x76);
})(RegulaErrorCode || (RegulaErrorCode = {}));
var INSECURE_ORIGIN = _0x1933e8(0xfd);
var SignatureErrorCode;
(function (_0x35f9dc) {
  var _0x27263c = _0x1933e8;
  _0x35f9dc[_0x35f9dc['BROWSER_NOT_SUPPORTED'] = -0x1] = _0x27263c(0xb7), _0x35f9dc[_0x35f9dc[_0x27263c(0xf4)] = -0x2] = _0x27263c(0xf4), _0x35f9dc[_0x35f9dc['VIDEO_CREATION_FAIL'] = -0x3] = _0x27263c(0xf0), _0x35f9dc[_0x35f9dc[_0x27263c(0x8a)] = -0x4] = 'MEDIA_RECORDER_ERROR', _0x35f9dc[_0x35f9dc[_0x27263c(0x18b)] = -0x5] = _0x27263c(0x18b), _0x35f9dc[_0x35f9dc[_0x27263c(0xa5)] = -0x6] = _0x27263c(0xa5), _0x35f9dc[_0x35f9dc[_0x27263c(0x184)] = -0x7] = 'VIDEO_EMPTY', _0x35f9dc[_0x35f9dc[_0x27263c(0xaa)] = -0x8] = _0x27263c(0xaa), _0x35f9dc[_0x35f9dc[_0x27263c(0xe0)] = -0x9] = _0x27263c(0xe0), _0x35f9dc[_0x35f9dc[_0x27263c(0x10c)] = -0xa] = _0x27263c(0x10c), _0x35f9dc[_0x35f9dc['MEDIA_RECORDER_NOT_SUPPORTED'] = -0xb] = _0x27263c(0x160), _0x35f9dc[_0x35f9dc[_0x27263c(0x157)] = -0xc] = 'NO_AUDIO', _0x35f9dc[_0x35f9dc[_0x27263c(0x197)] = -0xd] = 'CONTEXT_SWITCH';
})(SignatureErrorCode || (SignatureErrorCode = {}));
var LivenessTocErrorCode;
(function (_0x33a555) {
  var _0x595693 = _0x1933e8;
  _0x33a555[_0x33a555[_0x595693(0xda)] = 0x0] = _0x595693(0xda), _0x33a555[_0x33a555[_0x595693(0x14c)] = 0x1] = _0x595693(0x14c), _0x33a555[_0x33a555[_0x595693(0x198)] = 0x2] = _0x595693(0x198), _0x33a555[_0x33a555[_0x595693(0xd7)] = 0x3] = _0x595693(0xd7), _0x33a555[_0x33a555[_0x595693(0x151)] = 0x4] = _0x595693(0x151), _0x33a555[_0x33a555[_0x595693(0xbe)] = 0x192] = _0x595693(0xbe), _0x33a555[_0x33a555[_0x595693(0x6c)] = 0x193] = _0x595693(0x6c), _0x33a555[_0x33a555[_0x595693(0xa9)] = 0x194] = _0x595693(0xa9), _0x33a555[_0x33a555[_0x595693(0x131)] = 0x195] = _0x595693(0x131), _0x33a555[_0x33a555['ENDPOINT_RESOLUTION_ERROR'] = 0x196] = 'ENDPOINT_RESOLUTION_ERROR', _0x33a555[_0x33a555[_0x595693(0xc2)] = 0x197] = 'CAMERA_NOT_AVAILABLE', _0x33a555[_0x33a555[_0x595693(0xb7)] = 0x198] = _0x595693(0xb7), _0x33a555[_0x33a555[_0x595693(0x1ac)] = 0x199] = _0x595693(0x1ac), _0x33a555[_0x33a555[_0x595693(0x6a)] = 0x19b] = _0x595693(0x6a), _0x33a555[_0x33a555[_0x595693(0x13e)] = 0x1ae] = 'FACE_VALIDATION_FAILED', _0x33a555[_0x33a555[_0x595693(0x1bd)] = 0x1c2] = _0x595693(0x1bd), _0x33a555[_0x33a555[_0x595693(0x165)] = 0x2bd] = 'SYSTEM_INTERNAL_ERROR', _0x33a555[_0x33a555[_0x595693(0x1a1)] = 0x2bf] = _0x595693(0x1a1), _0x33a555[_0x33a555['FACE_NOT_CENTERED'] = 0x2c0] = _0x595693(0xa8), _0x33a555[_0x33a555[_0x595693(0xdb)] = 0x2c1] = _0x595693(0xdb), _0x33a555[_0x33a555[_0x595693(0x158)] = 0x2c2] = _0x595693(0x158);
})(LivenessTocErrorCode || (LivenessTocErrorCode = {}));
var ValidationIdErrorCode;
(function (_0x367ae7) {
  var _0x2afd1d = _0x1933e8;
  _0x367ae7[_0x367ae7[_0x2afd1d(0xe8)] = -0x1] = 'NO_SERVICE', _0x367ae7[_0x367ae7[_0x2afd1d(0x13f)] = -0x2] = _0x2afd1d(0x13f), _0x367ae7[_0x367ae7[_0x2afd1d(0xa4)] = -0x3] = 'REQUIRED_CREDENTIALS', _0x367ae7[_0x367ae7[_0x2afd1d(0xc9)] = -0x4] = _0x2afd1d(0xc9), _0x367ae7[_0x367ae7[_0x2afd1d(0xbb)] = -0x5] = _0x2afd1d(0xbb), _0x367ae7[_0x367ae7[_0x2afd1d(0x1ae)] = -0x6] = 'FAILED_GET_VALIDATION', _0x367ae7[_0x367ae7[_0x2afd1d(0x11e)] = -0x7] = _0x2afd1d(0x11e), _0x367ae7[_0x367ae7['NO_CITIZEN_IDENTIFIER'] = -0x8] = _0x2afd1d(0x111), _0x367ae7[_0x367ae7[_0x2afd1d(0xa1)] = -0x9] = _0x2afd1d(0xa1), _0x367ae7[_0x367ae7[_0x2afd1d(0xbe)] = -0xa] = _0x2afd1d(0xbe), _0x367ae7[_0x367ae7['USER_NOT_CONFIGURED'] = -0xb] = 'USER_NOT_CONFIGURED', _0x367ae7[_0x367ae7['SERVICES_URL_NOT_CONFIGURED'] = -0xc] = 'SERVICES_URL_NOT_CONFIGURED', _0x367ae7[_0x367ae7[_0x2afd1d(0x7e)] = -0xd] = 'INVALID_DATA', _0x367ae7[_0x367ae7[_0x2afd1d(0x124)] = -0x64] = 'UNKNOWN';
})(ValidationIdErrorCode || (ValidationIdErrorCode = {}));
var VideoagreementErrorCode;
(function (_0xdd5d37) {
  var _0x395e67 = _0x1933e8;
  _0xdd5d37[_0xdd5d37[_0x395e67(0xb7)] = -0x1] = _0x395e67(0xb7), _0xdd5d37[_0xdd5d37['NOT_ACCEPT_CAMERA_PERMISSION'] = -0x2] = _0x395e67(0xf4), _0xdd5d37[_0xdd5d37[_0x395e67(0xf0)] = -0x3] = 'VIDEO_CREATION_FAIL', _0xdd5d37[_0xdd5d37[_0x395e67(0x8a)] = -0x4] = 'MEDIA_RECORDER_ERROR', _0xdd5d37[_0xdd5d37[_0x395e67(0x18b)] = -0x5] = 'FACE_UNDETECTED', _0xdd5d37[_0xdd5d37['REQUIRED_LEGEND'] = -0x6] = _0x395e67(0x144), _0xdd5d37[_0xdd5d37[_0x395e67(0x184)] = -0x7] = _0x395e67(0x184), _0xdd5d37[_0xdd5d37['NOT_READABLE_CAMERA'] = -0x8] = _0x395e67(0x10c), _0xdd5d37[_0xdd5d37[_0x395e67(0x160)] = -0x9] = _0x395e67(0x160), _0xdd5d37[_0xdd5d37[_0x395e67(0x157)] = -0xa] = _0x395e67(0x157), _0xdd5d37[_0xdd5d37['CONTEXT_SWITCH'] = -0xb] = _0x395e67(0x197), _0xdd5d37[_0xdd5d37[_0x395e67(0xe2)] = -0xc] = _0x395e67(0xe2);
})(VideoagreementErrorCode || (VideoagreementErrorCode = {}));
var VideotapingErrorCode;
(function (_0x181530) {
  var _0x40813b = _0x1933e8;
  _0x181530[_0x181530[_0x40813b(0xb7)] = -0x1] = 'BROWSER_NOT_SUPPORTED', _0x181530[_0x181530['NOT_ACCEPT_CAMERA_PERMISSION'] = -0x2] = _0x40813b(0xf4), _0x181530[_0x181530[_0x40813b(0xf0)] = -0x3] = _0x40813b(0xf0), _0x181530[_0x181530[_0x40813b(0x8a)] = -0x4] = _0x40813b(0x8a), _0x181530[_0x181530[_0x40813b(0x18b)] = -0x5] = 'FACE_UNDETECTED', _0x181530[_0x181530[_0x40813b(0x144)] = -0x6] = 'REQUIRED_LEGEND', _0x181530[_0x181530[_0x40813b(0x184)] = -0x7] = _0x40813b(0x184), _0x181530[_0x181530[_0x40813b(0x10c)] = -0x8] = _0x40813b(0x10c), _0x181530[_0x181530[_0x40813b(0x173)] = -0x9] = _0x40813b(0x173), _0x181530[_0x181530[_0x40813b(0x103)] = -0xa] = _0x40813b(0x103), _0x181530[_0x181530[_0x40813b(0x160)] = -0xb] = _0x40813b(0x160), _0x181530[_0x181530[_0x40813b(0xfc)] = -0xc] = _0x40813b(0xfc), _0x181530[_0x181530[_0x40813b(0x157)] = -0xd] = _0x40813b(0x157), _0x181530[_0x181530[_0x40813b(0x197)] = -0xe] = _0x40813b(0x197);
})(VideotapingErrorCode || (VideotapingErrorCode = {}));
var ResponseEvent = /*#__PURE__*/_createClass(function ResponseEvent(_0xb6b14a, _0x367f05) {
  _classCallCheck(this, ResponseEvent);
  var _0x13e415 = _0x1933e8;
  this['event'] = _0xb6b14a, this[_0x13e415(0x125)] = _0x367f05;
});
function startFadSDKProcess(_0x25d53b, _0x451243, _0x10f4b0) {
  return new Promise(function (_0x2fb0cc, _0x3d9112) {
    var _0x5c1925 = _0x587b;
    console[_0x5c1925(0x1af)](_0x5c1925(0xc4));
    var _0x4f4a = function _0x4f4a40(_0x30605d) {
      var _0x410e85;
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee() {
        var _0xe9c30;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _0xe9c30 = _0x587b;
              !isSecure(_0x30605d[_0xe9c30(0x87)], _0x10f4b0) && (window['removeEventListener'](_0xe9c30(0xc8), _0x4f4a), removeFadTagElement(_0x25d53b), _0x3d9112({
                'error': INSECURE_ORIGIN
              }));
              if (_0x30605d[_0xe9c30(0x125)][_0xe9c30(0x16c)] === EventModule['MODULE_READY']) console[_0xe9c30(0x1af)](_0xe9c30(0x85)), (_0x410e85 = _0x25d53b[_0xe9c30(0x17c)]) === null || _0x410e85 === void 0x0 ? void 0x0 : _0x410e85[_0xe9c30(0x1a7)](new ResponseEvent(EventModule[_0xe9c30(0x123)], _0x451243), _0x25d53b['src']);else {
                if (_0x30605d[_0xe9c30(0x125)]['event'] === EventModule[_0xe9c30(0x1a9)]) console[_0xe9c30(0x1af)]('Module\x20error'), window[_0xe9c30(0x1b2)](_0xe9c30(0xc8), _0x4f4a), removeFadTagElement(_0x25d53b), _0x3d9112(_0x30605d[_0xe9c30(0x125)][_0xe9c30(0x125)]);else {
                  if (_0x30605d[_0xe9c30(0x125)][_0xe9c30(0x16c)] === EventModule[_0xe9c30(0x159)] || _0x30605d[_0xe9c30(0x125)][_0xe9c30(0x16c)] === EventModule['SKIP_FINGERPRINTS']) console[_0xe9c30(0x1af)](_0xe9c30(0xab)), window[_0xe9c30(0x1b2)](_0xe9c30(0xc8), _0x4f4a), removeFadTagElement(_0x25d53b), _0x30605d[_0xe9c30(0x125)][_0xe9c30(0x199)] ? _0x2fb0cc({
                    'event': _0x30605d[_0xe9c30(0x125)][_0xe9c30(0x16c)],
                    'data': _0x30605d[_0xe9c30(0x125)]['data'],
                    'cryptoResult': _0x30605d[_0xe9c30(0x125)][_0xe9c30(0x199)]
                  }) : _0x2fb0cc({
                    'event': _0x30605d['data'][_0xe9c30(0x16c)],
                    'data': _0x30605d[_0xe9c30(0x125)][_0xe9c30(0x125)]
                  });else _0x30605d[_0xe9c30(0x125)][_0xe9c30(0x16c)] === EventModule['MODULE_CLOSED'] && (console['log'](_0xe9c30(0x18a)), window[_0xe9c30(0x1b2)]('message', _0x4f4a), removeFadTagElement(_0x25d53b), _0x2fb0cc({
                    'event': _0x30605d['data']['event']
                  }));
                }
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
    };
    window['addEventListener'](_0x5c1925(0xc8), _0x4f4a), addElementToFadTag(_0x25d53b);
  });
}
function startFadWebProcess(_0x129be0, _0xb0a566) {
  return new Promise(function (_0x440d3b, _0x3c3266) {
    var _0x7fb5e4 = _0x587b;
    console[_0x7fb5e4(0x1af)](_0x7fb5e4(0x177));
    var _0x = function _0x567823(_0x13a8f9) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee2() {
        var _0x43e5e1;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _0x43e5e1 = _0x587b;
              !isSecure(_0x13a8f9[_0x43e5e1(0x87)], _0xb0a566) && (window[_0x43e5e1(0x1b2)](_0x43e5e1(0xc8), _0x), removeFadTagElement(_0x129be0), _0x3c3266({
                'error': INSECURE_ORIGIN
              }));
              if (_0x13a8f9[_0x43e5e1(0x125)][_0x43e5e1(0x16c)] === EventModule['PROCESS_INIT']) console['log'](_0x43e5e1(0x1b9));else {
                if (_0x13a8f9[_0x43e5e1(0x125)]['event'] === EventModule[_0x43e5e1(0x1a9)]) console[_0x43e5e1(0x1af)]('Process\x20error'), window[_0x43e5e1(0x1b2)](_0x43e5e1(0xc8), _0x), removeFadTagElement(_0x129be0), _0x3c3266(_0x13a8f9[_0x43e5e1(0x125)]['data']);else {
                  if (_0x13a8f9[_0x43e5e1(0x125)][_0x43e5e1(0x16c)] === EventModule[_0x43e5e1(0x174)]) console[_0x43e5e1(0x1af)](_0x43e5e1(0x14f), _0x13a8f9['data'][_0x43e5e1(0x125)]);else _0x13a8f9['data']['event'] === EventModule['PROCESS_COMPLETED'] && (console[_0x43e5e1(0x1af)](_0x43e5e1(0xd2)), window['removeEventListener'](_0x43e5e1(0xc8), _0x), _0x440d3b(_0x13a8f9[_0x43e5e1(0x125)][_0x43e5e1(0x125)]));
                }
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
    };
    window[_0x7fb5e4(0x92)](_0x7fb5e4(0xc8), _0x), addElementToFadTag(_0x129be0);
  });
}
function startBiometricsProcess(_0x4f60aa, _0x57ccce) {
  return new Promise(function (_0x19e2cd, _0x582efe) {
    var _0x542a3f = _0x587b;
    console[_0x542a3f(0x1af)]('Starts\x20Biometrics\x20Process');
    var _0x5c1f7b2 = function _0x5c1f7b(_0x2400be) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee3() {
        var _0x2a918f;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _0x2a918f = _0x587b;
              !isSecure(_0x2400be[_0x2a918f(0x87)], _0x57ccce) && (window['removeEventListener'](_0x2a918f(0xc8), _0x5c1f7b2), removeFadTagElement(_0x4f60aa), _0x582efe({
                'error': INSECURE_ORIGIN
              }));
              if (_0x2400be[_0x2a918f(0x125)]['event'] === EventModule[_0x2a918f(0x193)]) console[_0x2a918f(0x1af)]('Process\x20init');else {
                if (_0x2400be[_0x2a918f(0x125)][_0x2a918f(0x16c)] === EventModule[_0x2a918f(0x1a9)]) console[_0x2a918f(0x1af)](_0x2a918f(0x88)), window[_0x2a918f(0x1b2)](_0x2a918f(0xc8), _0x5c1f7b2), removeFadTagElement(_0x4f60aa), _0x582efe(_0x2400be[_0x2a918f(0x125)][_0x2a918f(0x125)]);else {
                  if (_0x2400be[_0x2a918f(0x125)][_0x2a918f(0x16c)] === EventModule['ENTRY_PATH']) console[_0x2a918f(0x1af)]('Entry\x20path:\x20', _0x2400be['data'][_0x2a918f(0x125)]);else _0x2400be[_0x2a918f(0x125)][_0x2a918f(0x16c)] === EventModule[_0x2a918f(0x159)] && (console[_0x2a918f(0x1af)](_0x2a918f(0xd2)), window[_0x2a918f(0x1b2)](_0x2a918f(0xc8), _0x5c1f7b2), _0x19e2cd(_0x2400be[_0x2a918f(0x125)]['data']));
                }
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
    };
    window[_0x542a3f(0x92)]('message', _0x5c1f7b2), addElementToFadTag(_0x4f60aa);
  });
}
function isSecure(_0x597cf9, _0x3c3ffd) {
  var _0x2a2725, _0x132132;
  return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee4() {
    var _0x75a4a0, _t, _t2, _t3, _t4, _t5;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _0x75a4a0 = _0x587b;
          if (!_0x3c3ffd['environment']) {
            _context4.n = 2;
            break;
          }
          _t = _0x597cf9;
          _t2 = _0x75a4a0(0x17b);
          _context4.n = 1;
          return decipher(FAD_DOMAIN, YEK, VI);
        case 1:
          return _context4.a(2, _t[_t2].call(_t, _context4.v));
        case 2:
          if (!((_0x2a2725 = _0x3c3ffd === null || _0x3c3ffd === void 0x0 ? void 0x0 : _0x3c3ffd[_0x75a4a0(0x89)]) === null || _0x2a2725 === void 0x0 ? void 0x0 : _0x2a2725[_0x75a4a0(0xb4)])) {
            _context4.n = 7;
            break;
          }
          _t3 = _0x597cf9;
          _t4 = _0x75a4a0(0x17b);
          _t5 = (_0x132132 = _0x3c3ffd === null || _0x3c3ffd === void 0x0 ? void 0x0 : _0x3c3ffd['security']) === null || _0x132132 === void 0x0 ? void 0x0 : _0x132132[_0x75a4a0(0x10e)];
          if (_t5) {
            _context4.n = 4;
            break;
          }
          _context4.n = 3;
          return decipher(FAD_DOMAIN, YEK, VI);
        case 3:
          _t5 = _context4.v;
        case 4:
          if (!_t3[_t4].call(_t3, _t5)) {
            _context4.n = 5;
            break;
          }
          return _context4.a(2, !![]);
        case 5:
          return _context4.a(2, ![]);
        case 6:
          _context4.n = 8;
          break;
        case 7:
          return _context4.a(2, !![]);
        case 8:
          return _context4.a(2);
      }
    }, _callee4);
  }));
}
function removeFadTagElement(_0x392b56) {
  var _0x39d64c = _0x1933e8;
  var _0x59ac8c, _0x16bc70;
  var _0xa81113 = getFadTag();
  ((_0x59ac8c = _0xa81113 === null || _0xa81113 === void 0x0 ? void 0x0 : _0xa81113[_0x39d64c(0x189)]) === null || _0x59ac8c === void 0x0 ? void 0x0 : _0x59ac8c[_0x39d64c(0xba)]()) && ((_0x16bc70 = _0xa81113 === null || _0xa81113 === void 0x0 ? void 0x0 : _0xa81113['shadowRoot']) === null || _0x16bc70 === void 0x0 ? void 0x0 : _0x16bc70[_0x39d64c(0x138)](_0x392b56));
}
function getFadTag() {
  var _0x472f6 = _0x1933e8;
  return document['body'][_0x472f6(0x1ba)]('#fad-sdk');
}
function addElementToFadTag(_0x289c45) {
  var _0xbce51 = _0x1933e8;
  var _0x519063;
  var _0x5cef46 = getFadTag();
  (_0x519063 = _0x5cef46 === null || _0x5cef46 === void 0x0 ? void 0x0 : _0x5cef46[_0xbce51(0x189)]) === null || _0x519063 === void 0x0 ? void 0x0 : _0x519063[_0xbce51(0x99)](_0x289c45);
}
function addFadTag(_0x137d22) {
  var _0x239ed5 = _0x1933e8;
  var _0x29ac88;
  var _0x2e3d32 = _0x239ed5(0xf9),
    _0x13fc90 = document[_0x239ed5(0x120)](_0x239ed5(0xf9));
  _0x13fc90['id'] = _0x2e3d32;
  var _0x159a5a = (_0x29ac88 = _0x137d22 === null || _0x137d22 === void 0x0 ? void 0x0 : _0x137d22['zIndex']) === null || _0x29ac88 === void 0x0 ? void 0x0 : _0x29ac88['toString']();
  return _0x13fc90[_0x239ed5(0x194)]['zIndex'] = _0x159a5a || _0x239ed5(0x190), _0x13fc90;
}
function createIframe(_0x978562, _0x2259a4, _0x2a134b, _0x127297, _0x18c770) {
  var _0x8492f3 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !![];
  var _0xba649a = _0x1933e8,
    _0x150dd3 = document['createElement'](_0xba649a(0x1a0));
  return _0x127297[_0xba649a(0x116)](function (_0x2e6d5b) {
    var _0x258c53 = _0xba649a;
    _0x150dd3[_0x258c53(0x191)][_0x258c53(0xd4)](_0x2e6d5b);
  }), _0x150dd3['allow'] = _0x18c770, _0x150dd3[_0xba649a(0x84)] = _0x8492f3, _0x150dd3[_0xba649a(0x194)][_0xba649a(0x9d)] = '0', _0x150dd3[_0xba649a(0x194)]['position'] = _0xba649a(0x152), _0x150dd3[_0xba649a(0x194)][_0xba649a(0x7a)] = _0xba649a(0xa3), _0x150dd3[_0xba649a(0x194)][_0xba649a(0xb2)] = _0xba649a(0xa3), _0x150dd3[_0xba649a(0x194)][_0xba649a(0x1ad)] = '0', _0x150dd3[_0xba649a(0x194)][_0xba649a(0x7f)] = '0', _0x150dd3[_0xba649a(0x194)][_0xba649a(0x9a)] = _0xba649a(0xaf), _0x150dd3[_0xba649a(0x1b0)] = _0x2259a4 + _0xba649a(0x9f) + _0x2a134b, _0x150dd3;
}
function decipher(_0x54ff0e, _0x18ca82, _0xa019cf) {
  return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee5() {
    var _0x631f08, _0x6061c, _0x39ae28, _t6, _t7, _t8;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _0x631f08 = _0x587b;
          _t6 = window[_0x631f08(0x181)][_0x631f08(0x186)];
          _t7 = _0x631f08(0x185);
          _t8 = {
            'name': _0x631f08(0x13a),
            'iv': base64ToBytes(_0xa019cf)
          };
          _context5.n = 1;
          return parseKey(_0x18ca82);
        case 1:
          _context5.n = 2;
          return _t6[_t7].call(_t6, _t8, _context5.v, base64ToBytes(_0x54ff0e));
        case 2:
          _0x6061c = _context5.v;
          _0x39ae28 = new TextDecoder();
          return _context5.a(2, _0x39ae28['decode'](_0x6061c));
      }
    }, _callee5);
  }));
}
function base64ToBytes(_0xe38ae3) {
  var _0x52ad70 = _0x1933e8,
    _0x5bbf86 = atob(_0xe38ae3),
    _0x28f5c7 = new Uint8Array(_toConsumableArray(_0x5bbf86)[_0x52ad70(0x161)](function (_0x1ee461) {
      return _0x1ee461[_0x52ad70(0x178)](0x0);
    }));
  return _0x28f5c7[_0x52ad70(0x175)];
}
function parseKey(_0x3093cb) {
  return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee6() {
    var _0x1f5bfb, _0x3a5ee0, _0x308a37;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _0x1f5bfb = _0x587b;
          _0x3a5ee0 = base64ToBytes(_0x3093cb);
          _context6.n = 1;
          return window['crypto'][_0x1f5bfb(0x186)][_0x1f5bfb(0xe7)](_0x1f5bfb(0x11a), _0x3a5ee0, _0x1f5bfb(0x13a), ![], [_0x1f5bfb(0x126), _0x1f5bfb(0x185)]);
        case 1:
          _0x308a37 = _context6.v;
          return _context6.a(2, _0x308a37);
      }
    }, _callee6);
  }));
}
var FadSDK = /*#__PURE__*/function (_x1933e, _x1933e2, _x1933e3, _x1933e4, _x1933e5, _x1933e6, _x1933e7, _x1933e8, _x1933e9, _x1933e0, _x1933e1, _x1933e10, _x1933e11, _x1933e12) {
  function FadSDK(_0x5f00f6, _0xa87825) {
    _classCallCheck(this, FadSDK);
    var _0x39dcb4 = _0x1933e8;
    this['tkn'] = '', this['iframeId'] = 'fad-sdk-iframe', this[_0x39dcb4(0xf6)] = _0x5f00f6, this['options'] = _0xa87825 || SDK_OPTIONS, this[_0x39dcb4(0x148)] = addFadTag(_0xa87825 === null || _0xa87825 === void 0x0 ? void 0x0 : _0xa87825[_0x39dcb4(0x194)]), document[_0x39dcb4(0x121)][_0x39dcb4(0x99)](this[_0x39dcb4(0x148)]);
  }
  return _createClass(FadSDK, [{
    key: _x1933e,
    value: function value(_0xc22460, _0x42c605, _0x3fe9bc) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee7() {
        var _0x55e0ca, _0x7d484a, _t9, _t0, _t1, _t10, _t11;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _0x55e0ca = _0x587b;
              _t9 = createIframe;
              _t0 = this[_0x55e0ca(0x9e)];
              _context7.n = 1;
              return this[_0x55e0ca(0x119)]();
            case 1:
              _t1 = _context7.v;
              _t10 = '' + _t1;
              _t11 = MODULES_URL[_0x55e0ca(0x1b7)];
              _0x7d484a = _t9(_t0, _t10 + _t11, this[_0x55e0ca(0xf6)], [SandBoxPermissions[_0x55e0ca(0x122)], SandBoxPermissions[_0x55e0ca(0x10b)]], IframePermissions[_0x55e0ca(0x6e)]);
              return _context7.a(2, startFadSDKProcess(_0x7d484a, {
                'credentials': _0xc22460,
                'configuration': _0x42c605,
                'middleware': _0x3fe9bc
              }, this['options']));
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: _x1933e2,
    value: function value(_0x86abb9, _0x4d00ee, _0xd2b646, _0x2bfbf1, _0x29a720) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee8() {
        var _0x1c0ce8, _0x25c9b4, _t12, _t13, _t14, _t15, _t16, _t17, _t18;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _0x1c0ce8 = _0x587b;
              console[_0x1c0ce8(0x1af)](_0x1c0ce8(0xc0));
              _t12 = console;
              _t13 = _0x1c0ce8(0x1af);
              _context8.n = 1;
              return this[_0x1c0ce8(0x119)]();
            case 1:
              _t12[_t13].call(_t12, _context8.v);
              _t14 = createIframe;
              _t15 = this['iframeId'];
              _context8.n = 2;
              return this[_0x1c0ce8(0x119)]();
            case 2:
              _t16 = _context8.v;
              _t17 = '' + _t16;
              _t18 = MODULES_URL[_0x1c0ce8(0xcc)];
              _0x25c9b4 = _t14(_t15, _t17 + _t18, this['tkn'], [SandBoxPermissions[_0x1c0ce8(0x122)], SandBoxPermissions[_0x1c0ce8(0x10b)]], 'camera');
              return _context8.a(2, startFadSDKProcess(_0x25c9b4, {
                'credentials': _0x86abb9,
                'idData': _0x4d00ee,
                'idPhoto': _0xd2b646,
                'manualCapture': _0x2bfbf1,
                'configuration': _0x29a720
              }, this[_0x1c0ce8(0xdd)]));
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: _x1933e3,
    value: function value(_0x18e91f, _0xa58294, _0x133f23, _0x29d7fb, _0x507016) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee9() {
        var _0x58c602, _0x1de885, _t19, _t20, _t21, _t22, _t23;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _0x58c602 = _0x587b;
              console[_0x58c602(0x1af)](_0x58c602(0xd3));
              _t19 = createIframe;
              _t20 = this['iframeId'];
              _context9.n = 1;
              return this[_0x58c602(0x119)]();
            case 1:
              _t21 = _context9.v;
              _t22 = '' + _t21;
              _t23 = MODULES_URL['REGULA'];
              _0x1de885 = _t19(_t20, _t22 + _t23, this[_0x58c602(0xf6)], [SandBoxPermissions['ALLOW_SCRIPTS'], SandBoxPermissions[_0x58c602(0x10b)]], IframePermissions[_0x58c602(0x6e)]);
              return _context9.a(2, startFadSDKProcess(_0x1de885, {
                'credentials': _0x18e91f,
                'idData': _0x133f23,
                'idPhoto': _0x29d7fb,
                'configuration': _0x507016,
                'captureType': _0xa58294
              }, this[_0x58c602(0xdd)]));
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: 'startVideoagreement',
    value: function startVideoagreement(_0x1d1764, _0x17bd1a) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee0() {
        var _0x5de85f, _0x55db00, _t24, _t25, _t26, _t27, _t28;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _0x5de85f = _0x587b;
              _t24 = createIframe;
              _t25 = this[_0x5de85f(0x9e)];
              _context0.n = 1;
              return this['getBaseUrl']();
            case 1:
              _t26 = _context0.v;
              _t27 = '' + _t26;
              _t28 = MODULES_URL[_0x5de85f(0xfa)];
              _0x55db00 = _t24(_t25, _t27 + _t28, this[_0x5de85f(0xf6)], [SandBoxPermissions[_0x5de85f(0x122)], SandBoxPermissions[_0x5de85f(0x10b)]], IframePermissions[_0x5de85f(0x102)]);
              return _context0.a(2, startFadSDKProcess(_0x55db00, {
                'legend': _0x1d1764,
                'configuration': _0x17bd1a
              }, this['options']));
          }
        }, _callee0, this);
      }));
    }
  }, {
    key: _x1933e4,
    value: function value(_0x4d4548, _0x5480f2, _0x6c3d95) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee1() {
        var _0xb6389e, _0x1bc30c, _t29, _t30, _t31, _t32, _t33;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _0xb6389e = _0x587b;
              _t29 = createIframe;
              _t30 = this['iframeId'];
              _context1.n = 1;
              return this[_0xb6389e(0x119)]();
            case 1:
              _t31 = _context1.v;
              _t32 = '' + _t31;
              _t33 = MODULES_URL[_0xb6389e(0x1b8)];
              _0x1bc30c = _t29(_t30, _t32 + _t33, this['tkn'], [SandBoxPermissions[_0xb6389e(0x122)], SandBoxPermissions[_0xb6389e(0x10b)]], IframePermissions[_0xb6389e(0x102)]);
              return _context1.a(2, startFadSDKProcess(_0x1bc30c, {
                'legend': _0x4d4548,
                'identifications': _0x5480f2,
                'configuration': _0x6c3d95
              }, this[_0xb6389e(0xdd)]));
          }
        }, _callee1, this);
      }));
    }
  }, {
    key: _x1933e5,
    value: function value(_0x3e1d88) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee10() {
        var _0x269015, _0x480761, _t34, _t35, _t36, _t37, _t38;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _0x269015 = _0x587b;
              _t34 = createIframe;
              _t35 = this[_0x269015(0x9e)];
              _context10.n = 1;
              return this[_0x269015(0x119)]();
            case 1:
              _t36 = _context10.v;
              _t37 = '' + _t36;
              _t38 = MODULES_URL['SIGNATURE'];
              _0x480761 = _t34(_t35, _t37 + _t38, this[_0x269015(0xf6)], [SandBoxPermissions[_0x269015(0x122)], SandBoxPermissions[_0x269015(0x10b)]], IframePermissions[_0x269015(0x102)]);
              return _context10.a(2, startFadSDKProcess(_0x480761, {
                'configuration': _0x3e1d88
              }, this[_0x269015(0xdd)]));
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: 'startValidationId',
    value: function startValidationId(_0x1328df, _0x14a7bd) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee11() {
        var _0x4c2677, _0x383db8, _t39, _t40, _t41, _t42, _t43;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _0x4c2677 = _0x587b;
              _t39 = createIframe;
              _t40 = this[_0x4c2677(0x9e)];
              _context11.n = 1;
              return this[_0x4c2677(0x119)]();
            case 1:
              _t41 = _context11.v;
              _t42 = '' + _t41;
              _t43 = MODULES_URL[_0x4c2677(0x11c)];
              _0x383db8 = _t39(_t40, _t42 + _t43, this[_0x4c2677(0xf6)], [SandBoxPermissions[_0x4c2677(0x122)], SandBoxPermissions[_0x4c2677(0x10b)], SandBoxPermissions['ALLOW_MODALS']], '');
              return _context11.a(2, startFadSDKProcess(_0x383db8, {
                'identificationData': _0x1328df,
                'configuration': _0x14a7bd
              }, this[_0x4c2677(0xdd)]));
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: _x1933e6,
    value: function value(_0x42a406, _0x35ae63, _0x38600a) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee12() {
        var _0x5a42e5, _0x2357c8, _t44, _t45, _t46, _t47, _t48;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _0x5a42e5 = _0x587b;
              _t44 = createIframe;
              _t45 = this['iframeId'];
              _context12.n = 1;
              return this['getBaseUrl']();
            case 1:
              _t46 = _context12.v;
              _t47 = '' + _t46;
              _t48 = MODULES_URL[_0x5a42e5(0x1b6)];
              _0x2357c8 = _t44(_t45, _t47 + _t48, this[_0x5a42e5(0xf6)], [SandBoxPermissions['ALLOW_SCRIPTS'], SandBoxPermissions['ALLOW_SAME_ORIGIN'], SandBoxPermissions[_0x5a42e5(0xcd)]], IframePermissions[_0x5a42e5(0x6e)]);
              return _context12.a(2, startFadSDKProcess(_0x2357c8, {
                'detectionModes': _0x42a406,
                'credentials': _0x35ae63,
                'configuration': _0x38600a
              }, this[_0x5a42e5(0xdd)]));
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: _x1933e7,
    value: function value(_0x33dd91) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee13() {
        var _0x3d87df, _0x2dd444, _0x4afcd3;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _0x3d87df = _0x587b;
              _context13.n = 1;
              return this['getWeb4BaseUrl']();
            case 1:
              _0x2dd444 = _context13.v;
              console[_0x3d87df(0x1af)]('URL:', '' + _0x2dd444 + _0x33dd91);
              _0x4afcd3 = createIframe(this[_0x3d87df(0x9e)], '' + _0x2dd444 + _0x33dd91, this[_0x3d87df(0xf6)], [SandBoxPermissions[_0x3d87df(0x122)], SandBoxPermissions['ALLOW_SAME_ORIGIN'], SandBoxPermissions[_0x3d87df(0xcd)], SandBoxPermissions['ALLOW_FORMS']], IframePermissions[_0x3d87df(0x12b)]);
              return _context13.a(2, startFadWebProcess(_0x4afcd3, this[_0x3d87df(0xdd)]));
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: _x1933e8,
    value: function value(_0x4a111e) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee14() {
        var _0x3a3f6e, _0x3a58fe, _0x5f01ff;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _0x3a3f6e = _0x587b;
              _context14.n = 1;
              return this[_0x3a3f6e(0xb3)]();
            case 1:
              _0x3a58fe = _context14.v;
              console[_0x3a3f6e(0x1af)](_0x3a3f6e(0x95), '' + _0x3a58fe + _0x4a111e);
              _0x5f01ff = createIframe(this[_0x3a3f6e(0x9e)], '' + _0x3a58fe + _0x4a111e, this[_0x3a3f6e(0xf6)], [SandBoxPermissions[_0x3a3f6e(0x122)], SandBoxPermissions[_0x3a3f6e(0x10b)], SandBoxPermissions[_0x3a3f6e(0xcd)], SandBoxPermissions['ALLOW_FORMS']], IframePermissions[_0x3a3f6e(0x12b)]);
              return _context14.a(2, startBiometricsProcess(_0x5f01ff, this[_0x3a3f6e(0xdd)]));
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: _x1933e9,
    value: function value() {
      var _0x3e77e4, _0x3e3de6;
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee15() {
        var _0x3be071, _0x25ef01, _t49;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _0x3be071 = _0x587b;
              if (!((_0x3e77e4 = this[_0x3be071(0xdd)]) === null || _0x3e77e4 === void 0x0 ? void 0x0 : _0x3e77e4[_0x3be071(0x8f)])) {
                _context15.n = 6;
                break;
              }
              _t49 = this['options']['environment'];
              _context15.n = _t49 === FadEnvironment['UAT'] ? 1 : _t49 === FadEnvironment[_0x3be071(0x1a4)] ? 2 : _t49 === FadEnvironment['PROD'] ? 3 : 4;
              break;
            case 1:
              _0x25ef01 = FAD_IFRAME_UAT;
              return _context15.a(3, 4);
            case 2:
              _0x25ef01 = FAD_IFRAME_UATHA;
              return _context15.a(3, 4);
            case 3:
              _0x25ef01 = FAD_IFRAME_PROD;
              return _context15.a(3, 4);
            case 4:
              _context15.n = 5;
              return decipher(_0x25ef01, YEK, VI);
            case 5:
              return _context15.a(2, _context15.v);
            case 6:
              return _context15.a(2, ((_0x3e3de6 = this['options']) === null || _0x3e3de6 === void 0x0 ? void 0x0 : _0x3e3de6['baseUrl']) ? this[_0x3be071(0xdd)][_0x3be071(0xff)] : FAD_IFRAME_UAT);
            case 7:
              return _context15.a(2);
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: 'getWeb4BaseUrl',
    value: function getWeb4BaseUrl() {
      var _0x3ca5a1, _0x1a7d34, _0x4bb2a9;
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee16() {
        var _0xd74565, _0x415bc3, _t50;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _0xd74565 = _0x587b;
              if (!((_0x3ca5a1 = this[_0xd74565(0xdd)]) === null || _0x3ca5a1 === void 0x0 ? void 0x0 : _0x3ca5a1[_0xd74565(0x8f)])) {
                _context16.n = 6;
                break;
              }
              _t50 = (_0x1a7d34 = this[_0xd74565(0xdd)]) === null || _0x1a7d34 === void 0x0 ? void 0x0 : _0x1a7d34[_0xd74565(0x8f)];
              _context16.n = _t50 === FadEnvironment[_0xd74565(0x78)] ? 1 : _t50 === FadEnvironment[_0xd74565(0x1a4)] ? 2 : _t50 === FadEnvironment['PROD'] ? 3 : 4;
              break;
            case 1:
              _0x415bc3 = FAD_WEB_UAT;
              return _context16.a(3, 4);
            case 2:
              _0x415bc3 = FAD_WEB_UATHA;
              return _context16.a(3, 4);
            case 3:
              _0x415bc3 = FAD_WEB_PROD;
              return _context16.a(3, 4);
            case 4:
              _context16.n = 5;
              return decipher(_0x415bc3, YEK, VI);
            case 5:
              return _context16.a(2, _context16.v);
            case 6:
              return _context16.a(2, ((_0x4bb2a9 = this[_0xd74565(0xdd)]) === null || _0x4bb2a9 === void 0x0 ? void 0x0 : _0x4bb2a9[_0xd74565(0xff)]) ? this[_0xd74565(0xdd)][_0xd74565(0xff)] : FAD_IFRAME_UAT);
            case 7:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: _x1933e0,
    value: function value() {
      var _0x5d1b56, _0x5bf617, _0x3c06f0;
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee17() {
        var _0x178778, _0xc73801, _t51;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _0x178778 = _0x587b;
              if (!((_0x5d1b56 = this['options']) === null || _0x5d1b56 === void 0x0 ? void 0x0 : _0x5d1b56[_0x178778(0x8f)])) {
                _context17.n = 6;
                break;
              }
              _t51 = (_0x5bf617 = this[_0x178778(0xdd)]) === null || _0x5bf617 === void 0x0 ? void 0x0 : _0x5bf617[_0x178778(0x8f)];
              _context17.n = _t51 === FadEnvironment['UAT'] ? 1 : _t51 === FadEnvironment['UATHA'] ? 2 : _t51 === FadEnvironment['PROD'] ? 3 : 4;
              break;
            case 1:
              _0xc73801 = FAD_BIOMETRICS_UAT;
              return _context17.a(3, 4);
            case 2:
              _0xc73801 = FAD_BIOMETRICS_UATHA;
              return _context17.a(3, 4);
            case 3:
              _0xc73801 = FAD_BIOMETRICS_PROD;
              return _context17.a(3, 4);
            case 4:
              _context17.n = 5;
              return decipher(_0xc73801, YEK, VI);
            case 5:
              return _context17.a(2, _context17.v);
            case 6:
              return _context17.a(2, ((_0x3c06f0 = this[_0x178778(0xdd)]) === null || _0x3c06f0 === void 0x0 ? void 0x0 : _0x3c06f0['baseUrl']) ? this['options'][_0x178778(0xff)] : FAD_IFRAME_UAT);
            case 7:
              return _context17.a(2);
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: _x1933e1,
    value: function value(_0x22dc94) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee18() {
        var _0x3e5a57, _0x58cc24, _t52, _t53, _t54, _t55, _t56;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              _0x3e5a57 = _0x587b;
              console[_0x3e5a57(0x1af)]('Capture\x20id\x20starts');
              _t52 = createIframe;
              _t53 = this[_0x3e5a57(0x9e)];
              _context18.n = 1;
              return this[_0x3e5a57(0x119)]();
            case 1:
              _t54 = _context18.v;
              _t55 = '' + _t54;
              _t56 = MODULES_URL[_0x3e5a57(0x72)];
              _0x58cc24 = _t52(_t53, _t55 + _t56, this[_0x3e5a57(0xf6)], [], IframePermissions['CAMERA']);
              return _context18.a(2, startFadSDKProcess(_0x58cc24, {
                'configuration': _0x22dc94
              }, this[_0x3e5a57(0xdd)]));
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: _x1933e10,
    value: function value(_0x1c9ef6, _0x44d332) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee19() {
        var _0x5f0ee3, _0x4584a5, _t57, _t58, _t59, _t60, _t61;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              _0x5f0ee3 = _0x587b;
              _t57 = createIframe;
              _t58 = this['iframeId'];
              _context19.n = 1;
              return this[_0x5f0ee3(0x119)]();
            case 1:
              _t59 = _context19.v;
              _t60 = '' + _t59;
              _t61 = MODULES_URL[_0x5f0ee3(0x143)];
              _0x4584a5 = _t57(_t58, _t60 + _t61, this[_0x5f0ee3(0xf6)], [SandBoxPermissions['ALLOW_SCRIPTS'], SandBoxPermissions['ALLOW_SAME_ORIGIN']], IframePermissions[_0x5f0ee3(0x102)]);
              return _context19.a(2, startFadSDKProcess(_0x4584a5, {
                'credentials': _0x1c9ef6,
                'configuration': _0x44d332
              }, this['options']));
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: _x1933e11,
    value: function value(_0x23ceb2, _0x209812) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regenerator().m(function _callee20() {
        var _0x377c08, _0x36434e, _t62, _t63, _t64, _t65, _t66;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              _0x377c08 = _0x587b;
              _t62 = createIframe;
              _t63 = this[_0x377c08(0x9e)];
              _context20.n = 1;
              return this[_0x377c08(0x119)]();
            case 1:
              _t64 = _context20.v;
              _t65 = '' + _t64;
              _t66 = MODULES_URL[_0x377c08(0x15e)];
              _0x36434e = _t62(_t63, _t65 + _t66, this['tkn'], [SandBoxPermissions['ALLOW_SCRIPTS'], SandBoxPermissions['ALLOW_SAME_ORIGIN']], IframePermissions[_0x377c08(0x6e)]);
              return _context20.a(2, startFadSDKProcess(_0x36434e, {
                'credentials': _0x23ceb2,
                'configuration': _0x209812
              }, this[_0x377c08(0xdd)]));
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: _x1933e12,
    value: function value() {
      var _0x4abcba = _0x1933e8;
      this[_0x4abcba(0x183)]();
    }
  }, {
    key: 'removeFadSdkElement',
    value: function removeFadSdkElement() {
      var _0x1db0c5 = _0x1933e8;
      document[_0x1db0c5(0x121)]['removeChild'](this[_0x1db0c5(0x148)]);
    }
  }], [{
    key: 'getFadEnvironments',
    value: function getFadEnvironments() {
      return FadEnvironment;
    }
  }]);
}(_0x1933e8(0xe5), _0x1933e8(0x16d), _0x1933e8(0x15b), _0x1933e8(0x80), _0x1933e8(0xfe), _0x1933e8(0x176), _0x1933e8(0xe6), _0x1933e8(0x1a8), _0x1933e8(0x119), _0x1933e8(0xb3), _0x1933e8(0xb8), _0x1933e8(0x1b1), _0x1933e8(0xf8), _0x1933e8(0x132));
FadSDK['Errors'] = {
  'Acuant': AcuantErrorCode,
  'Identy': IdentyErrorCode,
  'Signature': SignatureErrorCode,
  'ValidationId': ValidationIdErrorCode,
  'Videotaping': VideotapingErrorCode,
  'Videoagreement': VideoagreementErrorCode,
  'Facetec': {
    'Session': FacetecErrorCodeSession,
    'Status': FacetecErrorCodeStatus,
    'Middleware': IframeFacetecErrorCode,
    'Type': FacetecErrorType
  },
  'Regula': RegulaErrorCode,
  'CaptureId': CaptureIdErrorCode,
  'IdentyFace': IdentyFaceErrorCode,
  'LivenessToc': LivenessTocErrorCode
}, FadSDK[_0x1933e8(0xa7)] = {
  'EventModule': EventModule,
  'Regula': {
    'CaptureType': RegulaCaptureType
  },
  'Facetec': {
    'ProcessType': AdditionaInfoProcessType
  },
  'Videotaping': {
    'IdsAllowed': IDS_ALLOWED
  },
  'Videoagreement': {
    'LegendSpeedMode': LegendSpeedMode
  }
}, FadSDK[_0x1933e8(0xc5)] = _0x1933e8(0x187);
var FadSdkElement = /*#__PURE__*/function (_HTMLElement, _x1933e13) {
  function FadSdkElement() {
    var _this;
    _classCallCheck(this, FadSdkElement);
    var _0xf162a0 = _0x1933e8;
    _this = _callSuper(this, FadSdkElement), _this[_0xf162a0(0x180)], _this[_0xf162a0(0x14d)]({
      'mode': _0xf162a0(0x11f)
    });
    return _this;
  }
  _inherits(FadSdkElement, _HTMLElement);
  return _createClass(FadSdkElement, [{
    key: 'connectedCallback',
    value: function connectedCallback() {
      var _0x2dcc7c = _0x1933e8;
      var _0x794ee;
      this[_0x2dcc7c(0x167)](), (_0x794ee = this[_0x2dcc7c(0x189)]) === null || _0x794ee === void 0x0 ? void 0x0 : _0x794ee[_0x2dcc7c(0x99)](this[_0x2dcc7c(0x180)]), console[_0x2dcc7c(0x1af)](_0x2dcc7c(0x168));
    }
  }, {
    key: _x1933e13,
    value: function value() {
      var _0xdc802d = _0x1933e8;
      this[_0xdc802d(0x180)] = document[_0xdc802d(0x120)](_0xdc802d(0x6d)), this['_fadBackground']['style']['backgroundColor'] = _0xdc802d(0x1b5), this[_0xdc802d(0x180)]['style']['width'] = _0xdc802d(0xa3), this[_0xdc802d(0x180)][_0xdc802d(0x194)][_0xdc802d(0xb2)] = '100%', this[_0xdc802d(0x180)][_0xdc802d(0x194)]['position'] = _0xdc802d(0x152), this[_0xdc802d(0x180)][_0xdc802d(0x194)][_0xdc802d(0x7f)] = '0', this[_0xdc802d(0x180)][_0xdc802d(0x194)][_0xdc802d(0x1ad)] = '0';
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement), _0x1933e8(0x167));
function _0x3161() {
  var _0x454ba7 = ['startRegula', 'ERROR_BROWSER_VERSION_NOT_SUPPORTED', 'fad-iframe-videoagreement', 'TOC_LIVENESS', 'KEY_EXPIRED_OR_INVALID', 'MEDIA_RECORDER_NOT_SUPPORTED', 'map', 'ERROR_SERVER_INTERNAL', 'FACETEC_MIDDLEWARE_REQUEST_FAILED', 'SERVER_ERROR', 'SYSTEM_INTERNAL_ERROR', 'SKIP_FINGERPRINTS', '_initializeBackground', 'Fad\x20Sdk\x20Element\x20initialized', 'VIDEOCONFERENCE', 'UNEXPECTED_ACUANT_ERROR', 'NETWORK_ISSUES', 'event', 'startAcuant', 'OCR_NOT_FOUND', 'ERROR_WEBRTC_NOT_SUPPORTED', 'NO_CREDENTIALS', 'NO_FINGERS', 'NEVERIN_ITIALIZED', 'TEACHABLE_MACHINE_LOAD_FAIL', 'ENTRY_PATH', 'buffer', 'startIdentyFingerprints', 'Starts\x20FAD\x20Web\x204\x20Process', 'charCodeAt', 'USER_CANCELLED_FROM_NEW_USER_GUIDANCE', 'fad-iframe-identy', 'includes', 'contentWindow', 'CAMERA_NOT_RUNNING', '5112200OaUVlX', 'fad-iframe-signature', '_fadBackground', 'crypto', 'FEEDBACK_DIALOG_CLOSED', 'removeFadSdkElement', 'VIDEO_EMPTY', 'decrypt', 'subtle', '2.3.0-alpha.4', 'ERROR_LICENSE', 'shadowRoot', 'Module\x20closed', 'FACE_UNDETECTED', 'CARD_MATCH', 'DOCUMENT_READER', 'MODULE_LOAD_FAILED', 'USER_REQUIRED', '88888', 'sandbox', 'REGULA_ERROR', 'PROCESS_INIT', 'style', 'ERROR_PROCESSING', 'NEVER_INITIALIZED', 'CONTEXT_SWITCH', 'USER_DATA_REQUIRED', 'cryptoResult', '2WWvAKU', 'MAX_ATTEMPTS', 'MISSING_GUIDANCE_IMAGES', '2035676OrZCLU', 'FEEDBACK_MATCHING_ERROR', 'FAIL_GET_FACE_IMAGE', 'iframe', 'FACE_BLURRY', 'allow-scripts', 'OTHER', 'UATHA', 'CAMERA_SNAPSHOT', 'UNSUPPORTED_CAMERA', 'postMessage', 'startBiometrics', 'PROCESS_ERROR', 'FILE_FORMAT', 'FLASH', 'CAMERA_PERMISSION_DENIED', 'left', 'FAILED_GET_VALIDATION', 'log', 'src', 'startIdentyFace', 'removeEventListener', '6302208THxFCn', 'done', '#F2F2F2', 'IDENTY', 'FACETEC', 'VIDEOTAPING', 'Process\x20init', 'querySelector', 'WASM_ERROR', 'WORKER_ERROR', 'UNCONTROLLED_ERROR', 'DPI_NOT_ENOUGH', 'NOT_PREPARED', 'MISSING_SESSION_ID', 'FACE_IMAGE_NOT_FOUND', 'USER_CANCELLED', 'DIV', 'CAMERA', 'ALLOW_FULLSCREEN', 'camera', 'NO_LICENSE', 'CAPTURE_ID', 'fad-iframe-facetec', '2663082quoesc', 'ERROR_INVALID_FORMAT', 'TIME_OUT', 'FAIL_INITIALIZATION', 'UAT', 'define', 'width', '7640590audLWu', 'NOT_ALLOWED_USE_NON_IFRAME_CONSTRUCTOR', 'FaceTecSessionStatus', 'INVALID_DATA', 'top', 'startVideotaping', 'throw', '6lAKBlPagKFclCK3', 'CONNECTION_ERROR', 'allowFullscreen', 'Module\x20ready', 'NO_BASE_URL', 'origin', 'Process\x20error', 'security', 'MEDIA_RECORDER_ERROR', 'CAMERA_ACCEPTED', 'uONj0U8CQuvucMYgEKuxVRd/VKg2IjeinkNPhNtRW3YvHumwT6YLMrrhRSU+9tUiIR8w90l6GoYN3hQEgIAnjb4N', 'uONj0U8CQuv2ftA+Gaz5Uho5F68+JS6smERajd0NWX8jH+e+S+dZJ7rsETQjqLfkSFkkVuSR0hkmjkMy2jw=', 'FEEDBACK_CAMERA_ACQUIRING_FAILED', 'environment', 'value', 'IN_PROCESS', 'addEventListener', 'uONj0U8CQuv/dMQ2BaCxRhImH+A5OSiunldOn9NESHEoUaS8TeRJDAsScfQULGYiPrCMEgqEAw==', 'IMAGE_GLARED', 'URL:', 'INVALID_DEVICE_KEY_IDENTIFIER', 'allow-forms', 'fad-iframe-acuant', 'appendChild', 'zIndex', 'INCORRECT_FILE', 'NOT_SUPPORTED', 'border', 'iframeId', '?tkn=', 'DOCUMENT_NOT_READY', 'NO_CARD_TYPE', 'ID_MEX_FRONT', '100%', 'REQUIRED_CREDENTIALS', 'REQUIRED_SIGNATURE', 'RESOURCES_COULD_NOT_BE_LOADED_ON_LAST_INIT', 'Constants', 'FACE_NOT_CENTERED', 'INTERNET_CONNECTION_PROBLEMS', 'INVALID_SIGNATURE', 'Process\x20completed', 'IFRAME_NOT_ALLOWED_WITHOUT_PERMISSION', 'DIFFERENT_CARD_TYPE', 'DIFFERENT_ZONE', '888888', 'CAMERA_UNKNOWN_ERROR', 'get', 'height', 'getBiometricsBaseUrl', 'enable', 'NO_TEMPLATES_SPECIFIED', 'uONj0U8CQuvucMY/FKinXRU5G6M6fjyqjVtaislXVXc8Uey+DOoJPvzZExipQxt44xGO/77kZFnr', 'BROWSER_NOT_SUPPORTED', 'startCaptureId', '36181DNzWUh', 'hasChildNodes', 'USER_NOT_EXIST', 'fad-iframe-validation-id', 'INITIALIZED', 'TIMEOUT_EXCEEDED', 'EQUAL_SIDE', 'Acuant\x20starts', 'LANDSCAPE_MODE_NOT_ALLOWED', 'CAMERA_NOT_AVAILABLE', 'USER_CANCELLED_FROM_RETRY_GUIDANCE', 'Starts\x20FAD\x20SDK\x20Process', 'version', 'ID_PASSPORT', 'NON_PRODUCTION_MODE_DEVICE_KEY_IDENTIFIER_INVALID', 'message', 'BAD_CREDENTIALS', 'ERROR_REQUEST_EXPIRED', 'ERROR_WRONG_RESOLUTION', 'ACUANT_10', 'ALLOW_MODALS', 'TF_LITE_ERROR', 'MEDIUM', 'PREINITIALIZE', '3gcAHSV', 'Process\x20Completed', 'Regula\x20starts', 'add', 'ERROR_INVALID_JSON', 'NO_CAMERA', 'UNKNOWN_ERROR', 'STILL_LOADING_RESOURCES', 'INITIALIZATION_NOT_COMPLETED', 'INVALID_USER', 'FACE_NOT_FOUND', 'FAIL_CREATION_INSTANCE_DOCUMENT', 'options', 'SIGNATURE', 'NO_MODEL_URL', 'FAIL_LOAD_WASM', 'FEEDBACK_LICENSE_INVALID', 'VIDEO_PLAYING_ERROR', 'IMAGE_BLURRY', '22viDmlc', 'startFacetec', 'startFadWeb4', 'importKey', 'NO_SERVICE', 'ERROR_INVALID_AS_LEVEL', 'uONj0U8CQuv5eN06EL2lXRA4VKg2IjeinkNPhNtRW3YvHumwT6YLMrrhRSc2+dcjNFYoGVvnPPs088SCUpyhohh1KWnGgHoT', 'DEVICE_LOCKED_OUT', 'NOT_ALLOWED_USE_IFRAME_CONSTRUCTOR', 'ID_MEX_BACK', 'ERROR_INVALID_IMAGE', 'TIMEOUT', 'VIDEO_CREATION_FAIL', 'ALLOW_FORMS', 'FILE_SIZE', 'ALREADY_INITIALIZED', 'NOT_ACCEPT_CAMERA_PERMISSION', 'PROGRAMMATICALLY_CANCELLED', 'tkn', 'ID_NOT_FOUND', 'startLivenessToc', 'fad-sdk', 'VIDEOAGREEMENT', 'camera;microphone', 'IDENTIFICATIONS_REQUIRED', 'Insecure\x20origin', 'startSignature', 'baseUrl', 'LOCKED_OUT', 'allow-modals', 'CAMERA_MICROPHONE', 'TENSORFLOW_LOAD_FAIL', 'tv5lzF1ZGLD0dsA2E6j5VxwmBiMXgdKhcbAh3QpRUkXBBA==', 'USER_CANCELLED_WHEN_ATTEMPTING_TO_GET_CAMERA_PERMISSIONS', 'IDENTY_GENERIC', 'RESOURCES_COULD_NOT_BE_LOADED', 'ENROLLMENT', 'ORIENTATION_CHANGE_DURING_SESSION', 'SESSION_IN_PROGRESS', 'ALLOW_SAME_ORIGIN', 'NOT_READABLE_CAMERA', 'geolocation\x20*;\x20camera;\x20microphone', 'domain', 'TF_ERROR', 'MODEL_FAILED', 'NO_CITIZEN_IDENTIFIER', 'next', 'WASM_LICENSE', '1246LwXNLn', 'NO_CAPTURE_TYPE', 'forEach', 'BASE64', 'USER_CANCELLED_VIA_CLICKABLE_READY_SCREEN_SUBTEXT', 'getBaseUrl', 'raw', 'UNKNOWN_INTERNAL_ERROR', 'VALIDATION_ID', 'FAIL_INITIALIZATION_CAMERA_UI', 'FAILED_SEND_VALIDATION', 'open', 'createElement', 'body', 'ALLOW_SCRIPTS', 'INIT_MODULE', 'UNKNOWN', 'data', 'encrypt', 'ERROR_INVALID_MATCH_LEVEL', 'allow-same-origin', 'FAIL_UPLOAD_IMAGE', 'ALREADY_PREPARED', 'GEOLOCATION_CAMERA_MICROPHONE', 'DEVICE_NOT_SUPPORTED', 'JIxcqVf2MMP5dDS5PlcZdWRE00J9F8IGS/FyFPo0AEs=', 'fad-iframe-videotaping', 'PROD', 'MODULE_READY', 'INVALID_SESSION_ID', 'end', 'INCORRECT_CAMERA_ID', 'FILES_UPLOAD', 'ID_PHOTO_NOT_FOUND', 'apply', 'REQUIRED_MIDDLEWARE_INFO', 'removeChild', 'FAST', 'AES-GCM', 'UNSUPPORTED_IMAGE', 'VERSION_DEPRECATED', 'SLOW', 'FACE_VALIDATION_FAILED', 'NO_INTERNET', 'FACETEC_MIDDLEWARE_CREDENTIALS', 'CAMERA_NOT_ENABLED', 'FEEDBACK_RETRY', 'IDENTY_FACE', 'REQUIRED_LEGEND', '20256oDpEYt', 'uONj0U8CQuv6YdsxB6i6UV0tE7wyMTu2i1lcmd1FWz4tX+fwPVYP6TF2MAZND/ZPt6NHLA==', 'FEEDBACK_RETRY_INSECURE', 'fadSdkElement', 'uONj0U8CQuvucMY/FL6yVhUqHvpxNjOxkldanshMXWIvVuvxQeYLfL7uEz9o4dckPkc1S2jFRkEF2YhXDNIlAF4ides=', 'DEVICE_BROWSER_ERROR', 'ERROR_SERVER_CONNECTION_FAILURE', 'SERVICE_ERROR', 'attachShadow', 'MODULE_CLOSED', 'Entry\x20path:\x20', 'FAIL_GET_OCR', 'HTTPS_REQUIRED', 'fixed', 'FACE_IMAGE_URL_NOT_FOUND', 'ERROR_CLIENT_NOT_EXISTS', 'uONj0U8CQuvucMY/FKu+Wx4uDrw2MyntmV9Jht1CT2QhV/i+ROhIMLziVTw2/NB4I0MtH1HPLK8MgIW+mGJZBcafe8crpX5qaZw5Upg=', 'I_FRAME_NOT_ALLOWED_WITHOUT_PERMISSION', 'NO_AUDIO', 'FACE_TOO_FAR', 'PROCESS_COMPLETED', 'then'];
  _0x3161 = function _0x3161() {
    return _0x454ba7;
  };
  return _0x3161();
}
customElements[_0x1933e8(0xb1)]('fad-sdk') || customElements[_0x1933e8(0x79)](_0x1933e8(0xf9), FadSdkElement);
export { FadSDK as default };